import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";

import {
  selectIsAllCollectionsFetching,
  selectSpecialPreview,
} from "../../redux/shop/shop.selectors";
import { Item } from "../../redux/shop/shop.types";
import { shopActions } from "../../redux/shop/shop.reducer";

import useStyles from "./special-preview.styles";

import CollectionItem from "../collection-item";
import Loading from "../loading";

const SpecialPreview = () => {
  const dispatch = useDispatch();
  const classes = useStyles();

  const specialPreview = useSelector(selectSpecialPreview);
  const isFetching = useSelector(selectIsAllCollectionsFetching);

  // const fetchSpecialCollection = () => {
  //   dispatch({
  //     type: shopActions.fetchSpecialCollectionPreviewStart.type,
  //   });
  // };

  useEffect(() => {
    if (specialPreview.length === 0) {
      // fetchSpecialCollection();
    }
  }, []);

  return (
    <div className={classes.container}>
      <div className={classes.title}>Special</div>
      <Link to="/shop/special" className={classes.link}>
        View all
      </Link>
      {!isFetching ? (
        specialPreview.length === 0 ? (
          <div className={classes.noItemsFound}>No Items Found</div>
        ) : (
          <div className={classes.previewContainer}>
            {specialPreview.map((item: Item) => (
              <CollectionItem key={item.id} item={item} />
            ))}
          </div>
        )
      ) : (
        <Loading on size="3rem" marginTop="2rem" />
      )}
    </div>
  );
};

export default SpecialPreview;
